// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"25":"0bb88397","297":"a887f87c","644":"8e0c6268"}[chunkId] + ".css";
};